export default __webpack_public_path__ + "static/Foodservice-Photo2-7217e3e8087af8b42548a82c71403cac.png";